import React from 'react';
import styles from './style.module.scss';

export const RedCheckbox = (props:any) =>{
    const {disabled=false,checked,handleChange, page}=props;
    return (
        <div className={`${styles.checkboxWrapper} ${['RFQ', 'DQC'].includes(page?.pageType) ? 'toolBarDisabledIcon' : ''}`}>
            <label className={styles.checkboxLabel}>
            <input
                type="checkbox"
                disabled={disabled}
                checked={checked}
                className={styles.checkbox}
                onChange={handleChange}
            />
            <span className={styles.checkmark} />
            </label>
        </div>
    )
}